import { FilterFieldValue } from '../covance-filter';
import { HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { Injectable } from '@angular/core';

@Injectable()
export class ExternalUserFilterUrlParamsPreparer {
    public prepareFilterUrlParams(filterParameters: FilterFieldValue[]): HttpParams {
        if (!filterParameters) {
            return null;
        }

        let httpParams = new HttpParams();
        filterParameters
            .filter(p => p.value)
            .forEach((filterParam) => {
                const filterValue = filterParam.value;
                const paramName = filterParam.def.queryParam;

                if (paramName === 'visitCollectionDate') {
                    httpParams = httpParams.append('visitCollectionDateFrom', (filterValue.dateBegin) ? moment(filterValue.dateBegin).format('YYYY-MM-DDTHH:mm:ss') : '');
                    httpParams = httpParams.append('visitCollectionDateTo', (filterValue.dateEnd) ? moment(filterValue.dateEnd).format('YYYY-MM-DDTHH:mm:ss') : '');
                    return;
                }

                if (paramName === 'age') {
                    let operator: string = (filterValue.operator) ? filterValue.operator : '';
                    let dayParam: string = (filterValue.day) ? filterValue.day : '';
                    httpParams = httpParams.append('operator', encodeURIComponent(operator));
                    httpParams = httpParams.append('day', encodeURIComponent(dayParam));
                    return;
                }

                if (Array.isArray(filterValue)) {
                    filterValue
                        .forEach(v => {
                            let paramValue: string = (v.key) ? v.key : v;
                            httpParams = httpParams.append(paramName, encodeURIComponent(paramValue));
                        });
                } else {
                    let paramValue: string = (filterValue.key) ? filterValue.key : filterValue;
                    httpParams = httpParams.append(paramName, encodeURIComponent(paramValue));
                }
            });

        return httpParams;
    }
}